import PropTypes from 'prop-types';
import { memo, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import { usePopperTooltip } from 'shared/ui/Popper';

type PopperPopoverType = {
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
  [k: string]: any;
};
function PopperPopover(props: PropsWithChildren<PopperPopoverType>) {
  const { children, overlay, ...rest } = props;
  const [componenetVisible, setComponentVisible] = useState(false);

  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    interactive: true,
    ...rest,
  });

  const memoizedOverlay = useMemo(() => overlay, [overlay]);

  useEffect(() => {
    setComponentVisible(visible);
  }, [visible]);

  return (
    <>
      <div className="tooltip-wrapper-box" ref={setTriggerRef}>
        {children}
      </div>

      {componenetVisible &&
        ReactDOM.createPortal(
          <div ref={setTooltipRef} {...getTooltipProps({ className: 'tooltip-container' })}>
            {memoizedOverlay}
            <div {...getArrowProps({ className: 'tooltip-arrow' })} />
          </div>,
          document.body,
        )}
    </>
  );
}

PopperPopover.propTypes = {
  placement: PropTypes.string,
  overlay: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
  ]),
  closeOnOutsideClick: PropTypes.bool,
  closeOnTriggerHidden: PropTypes.bool,
  defaultVisible: PropTypes.bool,
  delayHide: PropTypes.number,
  delayShow: PropTypes.number,
  followCursor: PropTypes.bool,
  interactive: PropTypes.bool,
  mutationObserverOptions: PropTypes.shape({
    attributes: PropTypes.bool,
    childList: PropTypes.bool,
    subtree: PropTypes.bool,
  }),
  offset: PropTypes.arrayOf(PropTypes.number),
  trigger: PropTypes.string,
};

// eslint-disable-next-line import/no-default-export
export default memo(PopperPopover);
